
import React from "react";
import FormatSelectionDialog from "@/components/shared/FormatSelectionDialog";

interface TimetableFormatDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDownload: (format: 'jpg' | 'pdf') => void;
  totalRecords: number;
  reportTitle: string;
}

const TimetableFormatDialog = ({ 
  isOpen, 
  onClose, 
  onDownload,
  totalRecords,
  reportTitle
}: TimetableFormatDialogProps) => {
  return (
    <FormatSelectionDialog
      isOpen={isOpen}
      onClose={onClose}
      onDownload={onDownload}
      totalRecords={totalRecords}
      reportTitle={reportTitle}
    />
  );
};

export default TimetableFormatDialog;
